import axios from 'axios'
import { useEffect, useState } from 'react'

// Token-authenticated blob fetch -> object URL. <img> can't send the auth header,
// so we fetch the bytes and hand the browser a blob: URL. Returns null until loaded.
export const useStatusImageUrl = (s3Key, token) => {
  const [url, setUrl] = useState(null)
  useEffect(() => {
    if (!s3Key || !token) { setUrl(null); return }
    let revoked = false
    let objUrl = null
    axios.get('/apiv2/status_image/', {
      params: { key: s3Key },
      responseType: 'blob',
      headers: { Authorization: `Token ${token}` },
    }).then(r => {
      if (revoked) return
      objUrl = URL.createObjectURL(r.data)
      setUrl(objUrl)
    }).catch(() => setUrl(null))
    return () => { revoked = true; if (objUrl) URL.revokeObjectURL(objUrl) }
  }, [s3Key, token])
  return url
}

// Click-to-enlarge modal. Reused by the map and the dashboard tile.
export const StatusImageModal = ({ s3Key, token, onClose }) => {
  const url = useStatusImageUrl(s3Key, token)
  if (!s3Key) return null
  return (
    <div className="tm-img-modal" onClick={onClose}>
      <div className="tm-img-modal-body" onClick={e => e.stopPropagation()}>
        {url
          ? <img src={url} alt="status view" className="tm-img-full" />
          : <p className="tm-img-loading">Loading…</p>}
        <button className="tm-img-close" onClick={onClose}>×</button>
      </div>
    </div>
  )
}

// Small inline thumbnail in a FIXED-SIZE wrapper. The wrapper reserves layout space the
// moment it mounts (before the async blob image resolves), so a Leaflet popup containing it
// sizes correctly on the FIRST open instead of opening tiny and never resizing once the image
// arrives. Shows a placeholder while loading.
export const StatusImageThumb = ({ s3Key, token, onClick }) => {
  const url = useStatusImageUrl(s3Key, token)
  return (
    <div className="tm-img-thumb-wrap" onClick={onClick}>
      {url
        ? <img src={url} alt="status view" className="tm-img-thumb" />
        : <span className="tm-img-thumb-ph">…</span>}
    </div>
  )
}
